import { useTranslation } from 'react-i18next';
import { Card, Button, Title } from 'UI';
import {} from 'vopay';
import styles from './WorkflowCreatedDialog.module.scss';
import RolesSvg from './Roles.svg';

type WorkflowCreatedDialogProps = {
  onConfirm: (value: boolean) => void;
  onCancel: () => void;
};

export default function WorkflowCreatedDialog({ onConfirm, onCancel }: WorkflowCreatedDialogProps) {
  const { t } = useTranslation('translations', {
    keyPrefix: 'TransactionApproval.Configuration.Workflows.Update.Dialog',
  });

  return (
    <Card hoverEffect={false} className={styles.dialogCard}>
      <img className={styles.image} src={RolesSvg} alt="Roles" width={80} height={40} />
      <Title level="3">
        {t('title', {
          defaultValue: 'Assign Roles',
        })}
      </Title>
      <div className={styles.description}>
        {t('description', {
          defaultValue: 'Your workflow is ready. Choose who can review and approve payments.',
        })}
      </div>

      <div className={styles.buttonGroup}>
        <Button colorScheme="secondary" size="standard" onClick={onCancel} color="secondary">
          {t('skipForNow', { defaultValue: 'Skip for Now' })}
        </Button>
        <Button colorScheme="primary" size="standard" onClick={() => onConfirm(true)}>
          {t('assignRoles', { defaultValue: 'Assign Roles' })}
        </Button>
      </div>
    </Card>
  );
}
